import { useState } from "react"
import {
	IconCheckDoubleOutline18 as CheckCheckIcon,
	IconCloudUploadOutline18 as CloudUpload,
	IconMagnifierOutline18 as Search,
	IconCloudUploadOutline18 as UploadCloudIcon,
} from "nucleo-ui-outline-18"

import { Button } from "@productlane/ui"

import type { MarkdownArticle } from "../utils/markdown-parser"
import { parseMarkdownFiles } from "../utils/markdown-parser"
import { MarkdownPreviewDialog } from "./markdown-preview-dialog"
import { MarkdownUploadStep } from "./markdown-upload-step"

export function MarkdownUploadWizard() {
	const [step, setStep] = useState(0)
	const [articles, setArticles] = useState<MarkdownArticle[]>([])
	const [isParsing, setIsParsing] = useState(false)

	const handleFileInput = async (files: FileList) => {
		if (isParsing) return
		setIsParsing(true)
		try {
			const parsedArticles = await parseMarkdownFiles(files)
			setArticles(parsedArticles)
			setStep(1)
		} catch (error) {
			console.error("Error parsing markdown files:", error)
		} finally {
			setIsParsing(false)
		}
	}

	const reset = () => {
		setArticles([])
		setStep(0)
	}

	return (
		<div>
			{step === 0 && (
				<MarkdownUploadStep onSuccess={handleFileInput} isParsing={isParsing} />
			)}

			{step === 1 && (
				<div className="flex items-center justify-center p-8">
					<div className="flex flex-col items-center gap-2">
						<Search className="h-8 w-8 text-green-500" />
						<div className="text-sm text-secondary">
							{articles.length} article{articles.length !== 1 ? "s" : ""} ready
							to import
						</div>
						<div className="mt-2 flex gap-2">
							<Button
								className="text-secondary"
								size="sm"
								variant="ghost"
								onClick={reset}
								Icon={CloudUpload}
							>
								Upload Different File
							</Button>
							<Button size="sm" onClick={() => setStep(2)}>
								Preview & Upload
							</Button>
						</div>
					</div>
				</div>
			)}

			{step === 2 && (
				<MarkdownPreviewDialog
					onSuccess={() => setStep(3)}
					isOpen={true}
					onOpenChange={() => setStep(1)}
					articles={articles}
				/>
			)}

			{step === 3 && (
				<div className="flex items-center justify-center p-8">
					<div className="flex flex-col items-center gap-2">
						<CheckCheckIcon className="h-8 w-8 text-green-500" />
						<div className="text-secondary">Articles successfully uploaded</div>
						<Button
							className="text-secondary"
							size="sm"
							variant="ghost"
							Icon={UploadCloudIcon}
							onClick={reset}
						>
							Upload more files
						</Button>
					</div>
				</div>
			)}
		</div>
	)
}
